function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import compose from 'ramda/src/compose';
import contains from 'ramda/src/includes';
import flatten from 'ramda/src/flatten';
import groupBy from 'ramda/src/groupBy';
import map from 'ramda/src/map';
import partial from 'ramda/src/partial';
import pathOr from 'ramda/src/pathOr';
import pluck from 'ramda/src/pluck';
import prop from 'ramda/src/prop';
import propEq from 'ramda/src/propEq';
import sort from 'ramda/src/sort';
import values from 'ramda/src/values';
import { createSelector } from 'reselect';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import { BRI_ACTIVATION_STATUS } from 'invision-core/src/constants/pricing.plan.constants';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import CustomerCareKeys from '../../locales/keys';
import { getLastFourDigits } from '../helpers/wizard.selector.helper';
import { duplicatedServiceIdentifierAttributes } from '../helpers/offer.ordering.wizard.helper';
import { addressStateRegionProvinceValueOptionsForCountry } from './customer.selectors.helpers';
import { additionalPropertiesMergeValuesIntoTemplate } from 'invision-core/src/components/metadata/codes/codes.helpers';
import { CHARGE_TIMING, DEFAULT_SUMMARY_TAB_VIEW_MODEL } from '../constants/wizard.constants';
import { BILLER_RULE_CYCLE_LEVEL, BILLER_RULE_INSTANCE_TYPE, BILLER_RULE_QUANTITY_PRICE_TYPE, DELIVERY_OPTIONS, DOWN_PAYMENT_TYPE, INVENTORY_CATEGORY_CODE, ONE_TIME_WASH, TAX_RULE_OPTIONS, ZERO_TAX_AMOUNT } from '../../customercare.constants';
import { BRI_STATUS, DecisionTypes, DEVICE_SERVICE_FEATURE_ATTRIBUTE_ID, ScheduleTypes } from '../../components/wizards/steps/decisions/decisions.constants';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { INVENTORY_LOOKUP_TYPES } from '../../components/shared/constants/offering.option.status.constants';
import { EMPTY_ARRAY } from '../constants/common.constants';
import { EMPTY_OBJECT } from 'invision-core/src/constants/common.constants';
import { getUniqueNonGuidServiceIdentifiers } from './add.offer.wizard.selectors.helpers';
import cloneDeep from 'lodash/cloneDeep';
import { addressHelper as AddressHelper } from 'invision-core/src/utilities/address.helper';
var PLAN_OR_SERVICE_SWAP = 1;
export var InventoryAvailabilityRequests = function InventoryAvailabilityRequests(inputSelectors) {
  return createSelector(inputSelectors, function (formattedPhysicalAttributes, editCart) {
    var flattenedPhysicalAttributes = editCart && editCart.editPhysicalAttributeGroups ? flatten(values(editCart.editPhysicalAttributeGroups)) : [];
    return formattedPhysicalAttributes ? formattedPhysicalAttributes.map(function (_ref) {
      var Id = _ref.Id,
        PhysicalInventoryCompletedDecision = _ref.PhysicalInventoryCompletedDecision;
      return Object.assign(PhysicalInventoryCompletedDecision, {
        InventoryTypeId: flattenedPhysicalAttributes.find(function (attr) {
          return attr.id === Id;
        }).inventoryTypeId
      });
    }) : EMPTY_FORMATTED_ATTRIBUTES;
  });
};
export var BillingAddressStateRegionProvinceValueOptions = function BillingAddressStateRegionProvinceValueOptions(inputSelectors) {
  return createSelector(inputSelectors, function (paymentInfo, countries, states) {
    var selectedCountry = paymentInfo && paymentInfo.BillingAddress ? paymentInfo.BillingAddress.Country : null;
    return addressStateRegionProvinceValueOptionsForCountry(selectedCountry, countries, states);
  });
};
export var BillCycle = function BillCycle(inputSelectors) {
  return createSelector(inputSelectors, function (editCart) {
    return editCart.billCycle;
  });
};
export var Cart = function Cart(inputSelectors) {
  return createSelector(inputSelectors, function (wizardStore) {
    return wizardStore.cart;
  });
};
export var EditCart = function EditCart(inputSelectors) {
  return createSelector(inputSelectors, function (wizardStore) {
    return wizardStore.editCart;
  });
};
export var EditSelectedFacetIds = function EditSelectedFacetIds(inputSelectors) {
  return createSelector(inputSelectors, function (editCart) {
    return editCart.selectedFacetIds;
  });
};
export var EditSelectedOfferId = function EditSelectedOfferId(inputSelectors) {
  return createSelector(inputSelectors, function (editCart) {
    return editCart.selectedOfferId;
  });
};
var sortByDisplayOrder = function sortByDisplayOrder(a, b) {
  var aDisplayOrder = Object.keys(a.AdditionalProperties).filter(function (index) {
    return a.AdditionalProperties[index].Key === 'DisplayOrder';
  }).map(function (index) {
    return parseInt(a.AdditionalProperties[index].Value, 10);
  });
  var bDisplayOrder = Object.keys(b.AdditionalProperties).filter(function (index) {
    return b.AdditionalProperties[index].Key === 'DisplayOrder';
  }).map(function (index) {
    return parseInt(b.AdditionalProperties[index].Value, 10);
  });
  return aDisplayOrder[0] - bDisplayOrder[0];
};
export var GroupedCheckboxFilterOptions = function GroupedCheckboxFilterOptions(inputSelectors) {
  return createSelector(inputSelectors, function (facetCategories, facets, selectedFacetIds, selectedChargeTypeIds, isPostpaidEnabled, isPrepaidEnabled, isOfferTypesDisabled) {
    var sortedCategories = sort(sortByDisplayOrder, facetCategories);
    var options = [];
    if (sortedCategories && facets && selectedFacetIds) {
      options = sortedCategories.map(function (category) {
        var filteredFacets = facets.filter(function (facet) {
          var propertyWithOfferingFacetCategoryId = facet.AdditionalProperties.find(propEq('OfferingFacetCategoryId', 'Key'));
          return propertyWithOfferingFacetCategoryId && propertyWithOfferingFacetCategoryId.Value === category.Value.toString();
        });
        var filtersViewModel = sort(sortByDisplayOrder, filteredFacets).map(function (facet) {
          var facetId = facet.Value.toString();
          return {
            id: facetId,
            name: facet.Name,
            checked: selectedFacetIds.some(function (id) {
              return id === facetId;
            })
          };
        });
        return {
          groupName: category.Name,
          filters: filtersViewModel
        };
      });
    }
    return options;
  });
};
export var OfferOptionViewModel = function OfferOptionViewModel(inputSelectors) {
  return createSelector(inputSelectors, function (offers, selectedOfferId, multiOfferShoppingCartItems, ChangeOfferingId) {
    return offers.map(function (offer) {
      return offer.merge({
        isSelected: offer.Id === selectedOfferId,
        isDisabled: ChangeOfferingId === offer.Id
      }, {
        deep: true
      });
    });
  });
};
export var SelectedOfferId = function SelectedOfferId(inputSelectors) {
  return createSelector(inputSelectors, function (cart) {
    return cart.selectedOfferId;
  });
};
var defaultAttributeTypes = {
  isDropDownAttribute: false,
  isInputFieldAttribute: false,
  isMobileNumberPortabilityAttribute: false,
  isRadioAttribute: false,
  isTelephoneNumberLocationAttribute: false
};
export var FormAttributeGroupsHelper = function FormAttributeGroupsHelper(inputSelectors) {
  return createSelector(inputSelectors, function (editAttributeGroups, serviceAttribute) {
    var selectOption = {
      label: i18n.translate(CoreLocaleKeys.SELECT),
      value: undefined // must be undefined for required validation to work
    };
    return editAttributeGroups.map(function (attributeGroup, index) {
      var serviceFeatures = [];
      var attributes = attributeGroup.map(function (attribute) {
        Object.assign(attribute, defaultAttributeTypes);
        if (attribute.serviceFeatures) {
          serviceFeatures.push(attribute.serviceFeatures.map(function (serviceFeature) {
            return {
              allowEdit: attribute.allowEdit,
              attributeId: attribute.id,
              billerRuleDetails: serviceFeature.BillerRuleDetails,
              displayName: "".concat(serviceFeature.ProductName, ": ").concat(serviceFeature.PricingPlanName),
              pricingPlanId: serviceFeature.PricingPlanId,
              pricingPlanName: serviceFeature.PricingPlanName,
              productId: serviceFeature.ProductId,
              productName: serviceFeature.ProductName,
              serviceAttributeId: serviceFeature.ServiceAttributeId,
              serviceId: serviceFeature.ServiceId,
              serviceInstanceId: serviceFeature.ServiceInstanceId,
              subscriberProductId: serviceFeature.SubscriberProductId
            };
          }));
        }
        if (attribute.possibleValues && attribute.possibleValues.length > 0) {
          var newValues = [selectOption].concat(attribute.possibleValues.map(function (optionValue) {
            return {
              label: optionValue,
              value: optionValue
            };
          }));
          return Object.assign({}, attribute, {
            formValue: attribute.formValue ? attribute.formValue : newValues[0].value,
            isDropDownAttribute: true,
            possibleValues: newValues
          });
        } else if (attribute.isPortable && !attribute.passPortIn && attribute.inventoryLookupType === INVENTORY_LOOKUP_TYPES.TELEPHONE_NUMBER_LOCATION) {
          return Object.assign({}, attribute, {
            formValue: attribute.selectedValue,
            isTelephoneNumberLocationAttribute: true
          });
        } else if (attribute.inventoryItemReservation && attribute.inventoryCategoryCode === INVENTORY_CATEGORY_CODE.LOGICAL && !attribute.passPortIn) {
          return Object.assign({}, attribute, {
            formValue: attribute.selectedValue,
            isRadioAttribute: true
          });
        } else if (attribute.isPortable) {
          return Object.assign({}, attribute, {
            formValue: attribute.portInRequest && attribute.passPortIn ? attribute.portInRequest.portInData.existingNumber : null,
            isMobileNumberPortabilityAttribute: true
          });
        } else {
          return Object.assign({}, attribute, {
            isInputFieldAttribute: true
          });
        }
      });
      var serviceIdentifiers = attributes.filter(function (attribute) {
        return attribute.serviceIdentifier;
      });
      //Passing serviceAttribute for Edit and Change offer
      //https://jira.csgicorp.com/browse/ASCBR-1369
      if (attributes.length && serviceAttribute && Object.keys(serviceAttribute).length) {
        attributes.forEach(function (attribute) {
          attribute.serviceAttributeDisplayTypeCode = serviceAttribute[attribute.serviceAttributeId] && serviceAttribute[attribute.serviceAttributeId].AdditionalProperties && serviceAttribute[attribute.serviceAttributeId].AdditionalProperties.service_attribute_display_type_code || undefined;
        });
      }
      return {
        attributes: attributes,
        formName: "attributeForm".concat(index),
        isServiceFeatureAvailable: serviceIdentifiers.some(function (attribute) {
          return attribute.isServiceFeatureAvailable;
        }),
        isServiceFeatureEditable: serviceIdentifiers.some(function (attribute) {
          return attribute.allowEdit;
        }),
        serviceFeatures: serviceFeatures.length ? flatten(serviceFeatures) : EMPTY_ARRAY
      };
    });
  });
};
export var CurrentActiveAttributeNameHelper = function CurrentActiveAttributeNameHelper(inputSelectors) {
  return createSelector(inputSelectors, function (services) {
    var activeService = services && services.length ? services.find(function (service) {
      return service.isActive;
    }) : null;
    return activeService ? activeService.label : null;
  });
};
export var ShowPreviousButtonHelper = function ShowPreviousButtonHelper(inputSelectors) {
  return createSelector(inputSelectors, function (attributeServices) {
    if (attributeServices && attributeServices.length) {
      var activeService = attributeServices.find(function (service) {
        return service.isActive;
      });
      if (activeService) {
        var activeServiceIndex = attributeServices.indexOf(activeService);
        return activeServiceIndex > 0 && attributeServices.length > 1;
      }
    }
    return false;
  });
};
export var ShowNextButtonHelper = function ShowNextButtonHelper(inputSelectors) {
  return createSelector(inputSelectors, function (attributeServices) {
    if (attributeServices && attributeServices.length) {
      var activeService = attributeServices.find(function (service) {
        return service.isActive;
      });
      if (activeService) {
        var activeServiceIndex = attributeServices.indexOf(activeService);
        return activeServiceIndex < attributeServices.length - 1 && attributeServices.length > 1;
      }
    }
    return false;
  });
};
export var FilteredFormAttributeGroupsHelper = function FilteredFormAttributeGroupsHelper(inputSelectors) {
  return createSelector(inputSelectors, function (formAttributeGroups, attributeServices) {
    if (formAttributeGroups && formAttributeGroups.length && attributeServices && attributeServices.length) {
      var activeService = attributeServices.find(function (service) {
        return service.isActive;
      });
      if (activeService) {
        var group = formAttributeGroups.find(function (group) {
          return group.formName === activeService.formName;
        });
        if (group) {
          return [group];
        }
      }
    }
    return null;
  });
};
export var HasRequiredAndUnavailableInventory = function HasRequiredAndUnavailableInventory(inputSelectors) {
  return createImmutableSelector(inputSelectors, function (formAttributeGroups) {
    return formAttributeGroups && formAttributeGroups.length ? formAttributeGroups.some(function (attributeGroup) {
      return attributeGroup.attributes.some(function (attribute) {
        return attribute.isRequired && attribute.requestedInventoryIsUnavailable;
      });
    }) : false;
  });
};
export var FilteredPhysicalAttributeGroupsHelper = function FilteredPhysicalAttributeGroupsHelper(inputSelectors) {
  return createSelector(inputSelectors, function (formAttributeGroups, physicalGroups, currentAttributeFormName) {
    var services = [];
    if (formAttributeGroups && formAttributeGroups.length) {
      formAttributeGroups.forEach(function (attributeGroup, groupIndex) {
        var serviceObj = {
          formName: attributeGroup.formName,
          id: attributeGroup.formName,
          isActive: currentAttributeFormName ? attributeGroup.formName === currentAttributeFormName : groupIndex === 0
        };
        if (attributeGroup.attributes && attributeGroup.attributes.length) {
          //TODO: review this logic. Multiple properties of serviceObj are getting assigned from each items in attributes array. consequent items override perviously set values
          attributeGroup.attributes.forEach(function (attribute) {
            serviceObj.instanceNumber = attribute.instanceNumber;
            serviceObj.label = attribute.pricingPlanName;
            serviceObj.pricingPlanId = attribute.pricingPlanId;
          });
        }
        services.push(serviceObj);
      });
    }
    if (services && services.length) {
      var activeService = services && services.length ? services.find(function (service) {
        return service.isActive;
      }) : null;
      if (activeService) {
        var activeServiceIndex = services.indexOf(activeService);
        if (physicalGroups) {
          var filteredGroups = {};
          var _loop = function _loop() {
            if (group === String(activeService.pricingPlanId)) {
              filteredGroups[group] = physicalGroups[group].filter(function (physicalGroup) {
                return physicalGroup.instanceNumber === activeService.instanceNumber;
              });
              if (filteredGroups[group]) {
                var attributesGroup = currentAttributeFormName ? formAttributeGroups.find(function (attributeGroup) {
                  return attributeGroup.formName === currentAttributeFormName;
                }) : formAttributeGroups[0];
                filteredGroups[group].forEach(function (filteredGroup) {
                  filteredGroup.allowEdit = pathOr(true, ['allowEdit'], attributesGroup.attributes.find(function (attribute) {
                    return attribute.inventoryTypeId === filteredGroup.inventoryTypeId;
                  }));
                });
              }
            }
          };
          for (var group in physicalGroups) {
            _loop();
          }
          if (activeServiceIndex === 0) {
            var physicalGroupPricingPlans = Object.keys(physicalGroups);
            physicalGroupPricingPlans.forEach(function (pricingPlanId) {
              var foundService = services.find(function (service) {
                return String(service.pricingPlanId) === String(pricingPlanId);
              });
              if (!foundService) {
                filteredGroups[pricingPlanId] = physicalGroups[pricingPlanId];
              }
            });
          }
          return filteredGroups;
        }
      }
    }
    return physicalGroups;
  });
};
export var AllAttributesAreValidHelper = function AllAttributesAreValidHelper(inputSelectors) {
  return createSelector(inputSelectors, function (services, currentAttributesValidationStatuses) {
    if (services && services.length) {
      var invalidAttributeGroups = services.filter(function (service) {
        return !service.isValid;
      });
      if (!invalidAttributeGroups) {
        return true;
      } else {
        var problemsFound = false;
        invalidAttributeGroups.forEach(function (group) {
          var validationStatus = currentAttributesValidationStatuses.find(function (status) {
            return status.formName === group.formName;
          });
          if (!validationStatus && (group.hasRequiredItems || group.missingPhysicalInventoryAttributes) || validationStatus && !validationStatus.isValid) {
            problemsFound = true;
          }
        });
        return !problemsFound;
      }
    }
    return true;
  });
};
var activeAttributeItem = function activeAttributeItem(isHidden, index) {
  if (isHidden) {
    return false;
  } else {
    return index === 1 || index === 0;
  }
};
export var FormAttributeGroupsNavigationHelper = function FormAttributeGroupsNavigationHelper(inputSelectors) {
  return createSelector(inputSelectors, function (formAttributeGroups, formPhysicalAttributeGroups, currentAttributeFormName, attributeFormSubmitted, currentAttributesValidationStatuses, lastAttemptError) {
    var services = [];
    var faultData = pathOr([], ['faultData'], lastAttemptError);
    if (formAttributeGroups && formAttributeGroups.length) {
      var dupes = duplicatedServiceIdentifierAttributes(formAttributeGroups);
      formAttributeGroups.forEach(function (attributeGroup, groupIndex) {
        var serviceObj = {
          formName: attributeGroup.formName,
          hasRequiredItems: attributeGroup.attributes && attributeGroup.attributes.length ? !!attributeGroup.attributes.find(function (attribute) {
            return attribute.isRequired && !attribute.isHidden && !attribute.formValue;
          }) : false,
          id: attributeGroup.formName,
          isValid: null,
          hasRequiredAndUnavailableInventory: attributeGroup.attributes && attributeGroup.attributes.length ? attributeGroup.attributes.some(function (attribute) {
            return attribute.isRequired && attribute.requestedInventoryIsUnavailable;
          }) : false
        };
        attributeGroup.attributes.forEach(function (attribute) {
          serviceObj.instanceNumber = attribute.instanceNumber;
          serviceObj.isHidden = serviceObj.isHidden !== false && !attribute.isServiceFeatureAvailable && attribute.isHidden;
          serviceObj.isActive = currentAttributeFormName ? attributeGroup.formName === currentAttributeFormName : activeAttributeItem(serviceObj.isHidden, groupIndex);
          serviceObj.label = attribute.pricingPlanName;
          serviceObj.pricingPlanId = attribute.pricingPlanId;
          serviceObj.duplicateExists = !serviceObj.duplicateExists && dupes && dupes.length ? !!dupes.find(function (duplicate) {
            return duplicate === attribute.id;
          }) : serviceObj.duplicateExists;
          serviceObj.faultFound = !serviceObj.faultFound && faultData.length ? !!faultData.find(function (fault) {
            return fault === attribute.id;
          }) : serviceObj.faultFound;
          serviceObj.account = attribute.serviceIdentifier && attribute.formValue && !attribute.isHidden ? "(...".concat(getLastFourDigits(attribute.formValue), ")") : serviceObj.account;
        });
        var service = Object.assign({}, serviceObj, {
          isValid: validateAttributes(serviceObj, currentAttributesValidationStatuses, attributeFormSubmitted)
        });
        services.push(Object.assign({}, service, setServiceStatus(service)));
      });
    } else if (formPhysicalAttributeGroups && formPhysicalAttributeGroups.length === undefined) {
      // undefined is needed in conditional to validate formPhysicalAttributeGroups as object
      var mergedFormPhysicalAttributeGroups = flatten(values(formPhysicalAttributeGroups));
      var serviceObj = {
        // Hard coding values here because formName and id are null
        // when there is no attribute form to assign them to.
        formName: 'physicalAttributesNoService',
        id: 'physicalAttributesNoService',
        isActive: true,
        isValid: null,
        isHidden: true,
        hasRequiredItems: !!mergedFormPhysicalAttributeGroups.find(function (attribute) {
          return attribute.isRequired || !!attribute.typeAttributes.find(function (typeAttribute) {
            return typeAttribute.required;
          });
        })
      };
      var service = Object.assign({}, serviceObj, {
        isValid: validateAttributes(serviceObj, currentAttributesValidationStatuses, attributeFormSubmitted)
      });
      services.push(Object.assign({}, service, setServiceStatus(service)));
    }
    if (services && services.length && formPhysicalAttributeGroups) {
      services = validatePhysicalAttributes(services, formPhysicalAttributeGroups);
    }
    return services;
  });
};
var validatePhysicalAttributes = function validatePhysicalAttributes(services, formPhysicalAttributeGroups) {
  var clonedServices = clone(services);
  var physicalGroupsWithNoService = [];
  var activeService = services.find(function (service) {
    return service.isActive;
  });
  Object.keys(formPhysicalAttributeGroups).forEach(function (pricingPlanId) {
    var foundService = clonedServices.find(function (service) {
      return String(service.pricingPlanId) === String(pricingPlanId) && service.instanceNumber === activeService.instanceNumber;
    });
    if (!foundService) {
      physicalGroupsWithNoService.push(formPhysicalAttributeGroups[pricingPlanId]);
    } else {
      foundService.physicalGroups = [formPhysicalAttributeGroups[pricingPlanId].filter(function (group) {
        return group.instanceNumber === activeService.instanceNumber;
      })];
    }
  });
  clonedServices[0].physicalGroups = physicalGroupsWithNoService;
  var servicesToReturn = [];
  clonedServices.forEach(function (service) {
    var newService = service;
    if (service.physicalGroups && service.physicalGroups.length) {
      service.physicalGroups.forEach(function (physicalGroup) {
        physicalGroup.forEach(function (group) {
          var missingPhysicalAttributes = false;
          if (group.typeAttributes && group.typeAttributes.length) {
            var requiredPhysicalAttributes = group.typeAttributes.filter(function (attribute) {
              return attribute.required;
            });
            requiredPhysicalAttributes.forEach(function (attribute) {
              if (!missingPhysicalAttributes && (!group.selectedTypeAttributes || !group.selectedTypeAttributes[attribute.id])) {
                missingPhysicalAttributes = true;
              }
            });
          }
          if ((!group.selectedMake || !group.selectedModel || missingPhysicalAttributes) && service.isValid !== null) {
            var invalidObj = {
              isValid: false,
              missingPhysicalInventoryAttributes: true
            };
            newService = Object.assign({}, service, Object.assign({}, invalidObj, setServiceStatus(invalidObj)));
          }
        });
      });
    }
    servicesToReturn.push(newService);
  });
  return servicesToReturn;
};
var validateAttributes = function validateAttributes(serviceObj, currentAttributesValidationStatuses, attributeFormSubmitted) {
  var isValid = null;
  if (serviceObj.hasRequiredAndUnavailableInventory) {
    isValid = false;
  } else {
    var validationStatus = currentAttributesValidationStatuses && currentAttributesValidationStatuses.length ? currentAttributesValidationStatuses.find(function (status) {
      return status.formName === serviceObj.formName;
    }) : null;
    if (validationStatus) {
      isValid = validationStatus.isValid && !serviceObj.faultFound && !serviceObj.duplicateExists;
    } else {
      if (!attributeFormSubmitted) {
        isValid = serviceObj.duplicateExists ? false : null;
      } else {
        isValid = !serviceObj.hasRequiredItems && !serviceObj.faultFound && !serviceObj.duplicateExists;
      }
    }
  }
  return isValid;
};
var setServiceStatus = function setServiceStatus(serviceObj) {
  serviceObj.glyph = 'empty';
  serviceObj.glyphClass = 'c-navGroup-emptyRouteIcon';
  if (serviceObj.isValid === true) {
    serviceObj.glyph = 'status-complete-filled';
    serviceObj.glyphClass = 'is-active';
  }
  if (serviceObj.isValid === false) {
    serviceObj.glyph = 'status-pending-filled';
    serviceObj.glyphClass = 'is-removed';
  }
  return serviceObj;
};
export var populateDevice = function populateDevice(device) {
  device.makeInformationOptions = device.makeInformation.map(function (make) {
    return {
      text: make.name,
      value: make.id,
      //This is to check if user changed selection from previously selected make/model for saved offer
      selected: device.selectedMakeFromSavedCart && !device.selectedMake ? device.selectedMakeFromSavedCart === make.id : device.selectedMake === make.id
    };
  });
  if (device.makeInformationOptions.length === 1) {
    device.makeInformationOptions[0].selected = true;
    device.makeDisabled = true;
    device.selectedMake = device.makeInformationOptions[0].value;
  }
  device.modelsByMakeId = groupBy(prop('id'))(device.makeInformation);
  Object.keys(device.modelsByMakeId).forEach(function (key) {
    device.modelsByMakeId[key] = device.modelsByMakeId[key][0].possibleValues.map(function (item) {
      return {
        text: item.name,
        value: item.id,
        //This is to check if user changed selection from previously selected make/model for saved offer
        selected: device.selectedModelFromSavedCart && !device.selectedModel ? device.selectedModelFromSavedCart === item.id : device.selectedModel === item.id
      };
    });
  });
  if (device.selectedMake && device.modelsByMakeId[device.selectedMake] && 1 === device.modelsByMakeId[device.selectedMake].length) {
    device.modelsByMakeId[device.selectedMake][0].selected = true;
    device.modelDisabled = true;
    device.selectedModel = device.modelsByMakeId[device.selectedMake][0].value;
  }
  device.typeAttributeOptions = groupBy(prop('id'))(device.typeAttributes);
  device.typeAttributes.forEach(function (typeAttribute) {
    var selectedTypeAttribute = (device.selectedTypeAttributes || {})[typeAttribute.id] || undefined;

    /**
     * Set the default/selected value for attr
     * if there is no default value selected and
     * if there is only one option available.
     */
    if (undefined === selectedTypeAttribute && 1 === typeAttribute.possibleValues.length) {
      selectedTypeAttribute = typeAttribute.possibleValues[0];
    }
    device.typeAttributeOptions[typeAttribute.id] = {
      label: typeAttribute.name,
      values: typeAttribute.possibleValues.map(function (item) {
        return {
          text: item,
          value: item,
          selected: selectedTypeAttribute === item || item === typeAttribute.selectedValue
        };
      }),
      selectedValue: selectedTypeAttribute || typeAttribute.selectedValue,
      onlyOneValue: typeAttribute.possibleValues.length === 1
    };
  });
  return device;
};
export var FormPhysicalAttributeGroupsHelper = function FormPhysicalAttributeGroupsHelper(inputSelectors) {
  return createSelector(inputSelectors, function (editPhysicalAttributeGroups) {
    Object.keys(editPhysicalAttributeGroups || {}).forEach(function (key) {
      var devices = editPhysicalAttributeGroups[key];
      devices.forEach(function (device) {
        populateDevice(device);
      });
    });
    return editPhysicalAttributeGroups;
  });
};
export var UnavailablePhysicalInventory = function UnavailablePhysicalInventory(inputSelectors) {
  return createSelector(inputSelectors, function (editPhysicalAttributeGroups, availableInventory) {
    var allOptions = flatten(values(editPhysicalAttributeGroups || {}));
    var makeMap = {};
    var modelMap = {};
    var typeAttributeMap = {};
    allOptions.forEach(function (_ref2) {
      var makeInformation = _ref2.makeInformation,
        typeAttributes = _ref2.typeAttributes;
      makeInformation.forEach(function (_ref3) {
        var id = _ref3.id,
          name = _ref3.name,
          possibleValues = _ref3.possibleValues;
        makeMap[id] = name;
        possibleValues.forEach(function (model) {
          var toAdd = _defineProperty({}, model.id, model.name);
          modelMap[id] = modelMap[id] ? Object.assign(modelMap[id], toAdd) : toAdd;
        });
      });
      typeAttributes.forEach(function (_ref4) {
        var id = _ref4.id,
          name = _ref4.name;
        typeAttributeMap[id] = name;
      });
    });
    return editPhysicalAttributeGroups ? availableInventory.filter(function (_ref5) {
      var Available = _ref5.Available;
      return !Available;
    }).map(function (availability) {
      return {
        makeSelection: makeMap[availability.MakeId],
        modelSelection: pathOr(undefined, [availability.MakeId, availability.ModelId], modelMap),
        typeAttributeSelections: availability.InventoryAttributes.map(function (_ref6) {
          var AttributeId = _ref6.AttributeId,
            AttributeValue = _ref6.AttributeValue;
          return {
            label: typeAttributeMap[AttributeId],
            value: AttributeValue
          };
        }),
        quantityAvailable: availability.AvailableUnits
      };
    }).asMutable({
      deep: true
    }) : EMPTY_FORMATTED_ATTRIBUTES;
  });
};
export var getTypeTranslation = function getTypeTranslation(periodTypes, type, recurringPeriodType) {
  switch (type) {
    case BILLER_RULE_INSTANCE_TYPE.CUSTOM:
      return i18n.translate(CustomerCareKeys.BILLER_RULE_INSTANCE_TYPES.CUSTOM);
    case BILLER_RULE_INSTANCE_TYPE.ENTITLEMENT:
      return i18n.translate(CustomerCareKeys.BILLER_RULE_INSTANCE_TYPES.ENTITLEMENT);
    case BILLER_RULE_INSTANCE_TYPE.FINANCE:
      return i18n.translate(CustomerCareKeys.BILLER_RULE_INSTANCE_TYPES.FINANCE);
    case BILLER_RULE_INSTANCE_TYPE.ONETIME:
      return i18n.translate(CustomerCareKeys.BILLER_RULE_INSTANCE_TYPES.ONETIME);
    case BILLER_RULE_INSTANCE_TYPE.RECURRING:
      {
        if (periodTypes && periodTypes.length) {
          var periodTypeMatches = periodTypes.filter(function (periodType) {
            // RecurringPeriodType is in ELS and is only seeded at the moment
            // Should it become dyanmic then this kind of comparison won't work
            return convertStringToNumber(periodType.Value) === recurringPeriodType;
          });
          return "".concat(i18n.translate(CustomerCareKeys.BILLER_RULE_INSTANCE_TYPES.RECURRING), " ").concat(periodTypeMatches.length ? periodTypeMatches[0].Name : '');
        }
        break;
      }
    case BILLER_RULE_INSTANCE_TYPE.USAGE:
      return i18n.translate(CustomerCareKeys.BILLER_RULE_INSTANCE_TYPES.USAGE);
    default:
      return '';
  }
};
var hasOverriddenPrice = function hasOverriddenPrice(billerRules, shoppingCartItemBillerRuleDetails) {
  if (!shoppingCartItemBillerRuleDetails) {
    return false;
  }
  return billerRules.some(function (billerRule) {
    return contains(billerRule.BillerRuleConfigurationId, pluck('BillerRuleConfigurationId')(shoppingCartItemBillerRuleDetails));
  });
};
var getBillerRuleDetails = function getBillerRuleDetails(billerRules, shoppingCartItemBillerRuleDetails) {
  if (!hasOverriddenPrice(billerRules, shoppingCartItemBillerRuleDetails)) {
    return null;
  }
  var allOverriddenCharges = [];
  billerRules.forEach(function (billerRule) {
    var pricingPeriods = shoppingCartItemBillerRuleDetails.filter(function (item) {
      return item.BillerRuleConfigurationId === billerRule.BillerRuleConfigurationId;
    });
    var now = new Date().toISOString();
    var billerRuleDetails = pricingPeriods.find(function (period) {
      if (!period.StartDate) {
        return !period.EndDate ? true : period.EndDate > now;
      } else {
        if (period.EndDate) {
          return period.StartDate < now && period.EndDate > now;
        }
        return period.StartDate < now;
      }
    }) || {
      Amount: null,
      Quantity: null
    };
    allOverriddenCharges.push({
      amount: billerRuleDetails.Amount,
      quantity: billerRuleDetails.Quantity,
      type: billerRule.Type,
      billerRuleConfigurationId: billerRule.BillerRuleConfigurationId
    });
  });
  return allOverriddenCharges;
};
var combineItems = function combineItems(existingItems, shoppingCart) {
  var combinedItems = existingItems || [];
  if (shoppingCart.RemoveItems) {
    combinedItems = combinedItems.concat(shoppingCart.RemoveItems);
  }
  return combinedItems;
};
var filterInvalidItem = function filterInvalidItem(shoppingCartItem, billerRuleTotals) {
  var filteredBrits = [];
  var recurringBillerRuleInstances = pathOr(EMPTY_ARRAY, ['Details', 'PricingPlan', 'PricingPlanBillerRuleInstances', 'RecurringBillerRuleInstances'], shoppingCartItem);
  var oneTimeBillerRuleInstances = pathOr(EMPTY_ARRAY, ['Details', 'PricingPlan', 'PricingPlanBillerRuleInstances', 'OneTimeBillerRuleInstances'], shoppingCartItem);
  var financeBillerRuleInstances = pathOr(EMPTY_ARRAY, ['Details', 'PricingPlan', 'PricingPlanBillerRuleInstances', 'FinanceBillerRuleInstances'], shoppingCartItem);
  var billerRuleInstanceThumbnails = pathOr(EMPTY_ARRAY, ['Details', 'PricingPlan', 'BillerRuleInstanceThumbnails'], shoppingCartItem);
  //TODO: Using BRITS since the api does not have PricingplanBillerRuleInstances for subcription offers in ITV.
  if (billerRuleInstanceThumbnails.length) {
    billerRuleInstanceThumbnails.forEach(function (brit) {
      if (brit.Type === BILLER_RULE_INSTANCE_TYPE.SUBSCRIPTION) {
        filteredBrits.push(brit);
      }
    });
  }
  if (recurringBillerRuleInstances.length && oneTimeBillerRuleInstances.length) {
    var recurringAndOneTimeBris = [];
    recurringBillerRuleInstances.forEach(function (rBri) {
      if ((rBri.QuantityPricingTypeCode === BILLER_RULE_QUANTITY_PRICE_TYPE.NONE || (rBri.QuantityPricingTypeCode === BILLER_RULE_QUANTITY_PRICE_TYPE.TIERED || rBri.QuantityPricingTypeCode === BILLER_RULE_QUANTITY_PRICE_TYPE.TAPERED) && hasMatchingBillerRuleInstance(rBri, billerRuleTotals)) && !isBillerRuleInstanceOneTimeWashed(rBri, pathOr([], ['Details', 'BillerRuleConfigurationDetails'], shoppingCartItem))) {
        recurringAndOneTimeBris.push(rBri);
      }
    });
    oneTimeBillerRuleInstances.forEach(function (oBri) {
      if ((oBri.QuantityPricingTypeCode === BILLER_RULE_QUANTITY_PRICE_TYPE.NONE || (oBri.QuantityPricingTypeCode === BILLER_RULE_QUANTITY_PRICE_TYPE.TIERED || oBri.QuantityPricingTypeCode === BILLER_RULE_QUANTITY_PRICE_TYPE.TAPERED) && hasMatchingBillerRuleInstance(oBri, billerRuleTotals)) && !isBillerRuleInstanceOneTimeWashed(oBri, pathOr([], ['Details', 'BillerRuleConfigurationDetails'], shoppingCartItem)) && !isBillerRuleInstanceOneTimePaid(billerRuleInstanceThumbnails, oBri)) {
        recurringAndOneTimeBris.push(oBri);
      }
    });
    if (recurringAndOneTimeBris.length) {
      filteredBrits.push(recurringAndOneTimeBris);
    }
  } else if (recurringBillerRuleInstances.length) {
    recurringBillerRuleInstances.forEach(function (rBri) {
      if ((rBri.QuantityPricingTypeCode === BILLER_RULE_QUANTITY_PRICE_TYPE.NONE || (rBri.QuantityPricingTypeCode === BILLER_RULE_QUANTITY_PRICE_TYPE.TIERED || rBri.QuantityPricingTypeCode === BILLER_RULE_QUANTITY_PRICE_TYPE.TAPERED) && hasMatchingBillerRuleInstance(rBri, billerRuleTotals)) && !isBillerRuleInstanceOneTimeWashed(rBri, pathOr([], ['Details', 'BillerRuleConfigurationDetails'], shoppingCartItem))) {
        filteredBrits.push(rBri);
      }
    });
  } else if (oneTimeBillerRuleInstances.length) {
    oneTimeBillerRuleInstances.forEach(function (oBri) {
      if ((oBri.QuantityPricingTypeCode === BILLER_RULE_QUANTITY_PRICE_TYPE.NONE || (oBri.QuantityPricingTypeCode === BILLER_RULE_QUANTITY_PRICE_TYPE.TIERED || oBri.QuantityPricingTypeCode === BILLER_RULE_QUANTITY_PRICE_TYPE.TAPERED) && hasMatchingBillerRuleInstance(oBri, billerRuleTotals)) && !isBillerRuleInstanceOneTimeWashed(oBri, pathOr([], ['Details', 'BillerRuleConfigurationDetails'], shoppingCartItem)) && !isBillerRuleInstanceOneTimePaid(billerRuleInstanceThumbnails, oBri)) {
        filteredBrits.push(oBri);
      }
    });
  }
  //For finance BRI we can have two charges on the cart, one for Due today and the other for Next Invoice,
  //so based on the number of charges adding the same BRI with differnt charge. So that we can sort based on charges and display multiple charge for the same BRI.
  if (financeBillerRuleInstances.length && billerRuleTotals.length) {
    billerRuleTotals.forEach(function (briTotal) {
      var financeBriWithBillerRuleTotals = Object.assign({}, financeBillerRuleInstances[0], {
        billerRuleTotal: briTotal
      });
      filteredBrits.push(financeBriWithBillerRuleTotals);
    });
  }
  return filteredBrits;
};

// This function is designed to make sure that out of the list of BillerRuleInstances, that we only display the ones that
// match the BillerRuleTotals. We are making sure that the Amount and Type on the BillerRuleInstance
// matches the BR Totals that are actually selected to display the correct information. This works for tiered and tapered
var hasMatchingBillerRuleInstance = function hasMatchingBillerRuleInstance(brit) {
  var billerRuleTotals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return billerRuleTotals.some(function (brt) {
    return brit.BillerRuleInstanceCharges.some(function (charge) {
      return charge.ChargeAmount === brt.Amount;
    }) && brt.Type === brit.Type;
  });
};
var isBillerRuleInstanceOneTimeWashed = function isBillerRuleInstanceOneTimeWashed(billerRuleInstanceThumbnail, billerRuleConfigurationDetails) {
  return billerRuleConfigurationDetails.some(function (brcDetails) {
    return brcDetails.BillerRuleConfigurationId === billerRuleInstanceThumbnail.BillerRuleConfigurationId && brcDetails.WashStatus === ONE_TIME_WASH.WASHED;
  });
};
var isBillerRuleInstanceOneTimePaid = function isBillerRuleInstanceOneTimePaid() {
  var billerRuleInstanceThumbnails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var billerRuleInstance = arguments.length > 1 ? arguments[1] : undefined;
  return billerRuleInstanceThumbnails.find(function (briDetails) {
    return briDetails.BillerRuleConfigurationId === billerRuleInstance.BillerRuleConfigurationId && briDetails.Type === BILLER_RULE_INSTANCE_TYPE.ONETIME && briDetails.Status === BRI_STATUS.PAID;
  });
};
export var GetFinancedProductGroupInCartSelector = function GetFinancedProductGroupInCartSelector(inputSelectors) {
  return createSelector(inputSelectors, function (financedItems, offerQuote) {
    financedItems.forEach(function (product) {
      var quoteItem = pathOr([], ['Items'], offerQuote).find(function (quoteItem) {
        return quoteItem.PricingPlan.Id === product.pricingPlanId && quoteItem.Product.Id === product.productId;
      });
      if (quoteItem) {
        product.financedFullAmount = quoteItem.FinancedFullAmount;
        product.taxAmount = quoteItem.TaxAmount || ZERO_TAX_AMOUNT;
        product.payPerAmount = quoteItem.Amount || ZERO_TAX_AMOUNT;
      }
    });
    return financedItems;
  });
};
export var GetOfferQuoteSelector = function GetOfferQuoteSelector(inputSelectors) {
  return createSelector(inputSelectors, function (offerWizardStore) {
    return offerWizardStore.quote;
  });
};
var getItemAmount = function getItemAmount(chargeQuotes) {
  if (chargeQuotes[0].ChargeQuoteTotals !== null) {
    return chargeQuotes[0].ChargeQuoteTotals[0].Amount;
  }
};
var getItemTaxAmount = function getItemTaxAmount(chargeQuotes) {
  if (chargeQuotes[0].TaxItemQuotes !== null) {
    return chargeQuotes[0].TaxItemQuotes[0].TaxItemQuoteTotals[0].Amount;
  }
};
var getShippingAmountForChargeTiming = function getShippingAmountForChargeTiming(offeringOrderQuote, chargeTiming) {
  if (offeringOrderQuote.ShippingQuote && offeringOrderQuote.ShippingQuote.ShippingQuoteTotals) {
    var shippingItem = offeringOrderQuote.ShippingQuote.ShippingQuoteTotals.find(function (item) {
      return item.ChargeTiming === chargeTiming;
    });
    return shippingItem ? shippingItem.Amount : undefined;
  }
};
var getItemQuotesForOffer = function getItemQuotesForOffer(offeringOrderQuote) {
  var serviceQuotesForOffer = [];
  if (offeringOrderQuote.OfferingQuotes && offeringOrderQuote.OfferingQuotes.length > 1) {
    offeringOrderQuote.OfferingQuotes.forEach(function (offering) {
      if (offering.ServiceQuotes) {
        serviceQuotesForOffer.push(offering.ServiceQuotes);
      }
    });
    var serviceQuotes = flatten(serviceQuotesForOffer);
    var itemQuotes = flatten(pluck('ItemQuotes', serviceQuotes));
    return itemQuotes;
  } else if (offeringOrderQuote.OfferingQuotes && offeringOrderQuote.OfferingQuotes.length) {
    return flatten(pluck('ItemQuotes', offeringOrderQuote.OfferingQuotes[0].ServiceQuotes));
  }
};
var mapOfferingQuoteProperties = function mapOfferingQuoteProperties(offeringOrderQuote) {
  var orderQuoteTotals = offeringOrderQuote.OfferingOrderQuoteTotals;
  var orderTaxQuote = offeringOrderQuote.TaxQuote ? offeringOrderQuote.TaxQuote.TaxQuoteTotals : undefined;
  var orderFeeQuote = offeringOrderQuote.FeeQuote ? offeringOrderQuote.FeeQuote.FeeQuoteTotals : undefined;
  var itemQuotes = getItemQuotesForOffer(offeringOrderQuote);
  var hasInvoiceItems = offeringOrderQuote.OfferingQuotes && offeringOrderQuote.OfferingQuotes.length ? offeringOrderQuote.OfferingQuotes[0].HasInvoiceItems : undefined;
  var offerName = offeringOrderQuote.OfferingQuotes && offeringOrderQuote.OfferingQuotes.length ? offeringOrderQuote.OfferingQuotes[0].OfferName : undefined;
  return {
    Currency: offeringOrderQuote.Currency,
    OrderQuoteTotals: orderQuoteTotals && orderQuoteTotals.map(function (orderQuoteTotal) {
      var taxQuoteItem = orderTaxQuote && orderTaxQuote.find(function (taxItem) {
        return taxItem.ChargeTiming === orderQuoteTotal.ChargeTiming;
      });
      var feeQuoteItem = orderFeeQuote && orderFeeQuote.find(function (feeItem) {
        return feeItem.ChargeTiming === orderQuoteTotal.ChargeTiming;
      });
      return {
        ChargeTiming: orderQuoteTotal.ChargeTiming,
        DiscountAmount: orderQuoteTotal.DiscountAmount,
        ShippingAmount: getShippingAmountForChargeTiming(offeringOrderQuote, orderQuoteTotal.ChargeTiming),
        SubTotalAmount: orderQuoteTotal.SubTotalAmount,
        TaxAmount: taxQuoteItem ? taxQuoteItem.Amount : undefined,
        FeeAmount: feeQuoteItem ? feeQuoteItem.Amount : undefined,
        TotalAmount: orderQuoteTotal.Amount
      };
    }),
    Items: itemQuotes && itemQuotes.map(function (itemQuote) {
      return {
        Amount: itemQuote.ChargeQuotes.length && getItemAmount(itemQuote.ChargeQuotes),
        ConnectedDate: itemQuote.ConnectedDate,
        FinancedFullAmount: itemQuote.FinancedFullAmount || undefined,
        Name: itemQuote.Name,
        OfferingInstanceId: itemQuote.OfferingInstanceId,
        OrderContractInstance: itemQuote.OrderContractInstance,
        OrderedOfferingName: offerName,
        PricingPlan: itemQuote.PricingPlan,
        Product: itemQuote.Product,
        Quantity: itemQuote.Quantity,
        SubscriberProductId: itemQuote.LockerItemId,
        TaxAmount: itemQuote.ChargeQuotes.length && getItemTaxAmount(itemQuote.ChargeQuotes)
      };
    }),
    HasInvoiceItems: hasInvoiceItems,
    IsCreditLimitBreached: offeringOrderQuote.SubscriberCreditAndFinanceLimit ? offeringOrderQuote.SubscriberCreditAndFinanceLimit.IsCreditLimitBreached : undefined,
    CreditLimit: offeringOrderQuote.SubscriberCreditAndFinanceLimit ? offeringOrderQuote.SubscriberCreditAndFinanceLimit.CreditLimit : undefined,
    AvailableCredit: offeringOrderQuote.SubscriberCreditAndFinanceLimit ? offeringOrderQuote.SubscriberCreditAndFinanceLimit.AvailableCredit : undefined,
    EarlyTerminationFeeAmount: offeringOrderQuote.EarlyTerminationFeeAmount
  };
};
export var GetOfferingOrderQuoteSelector = function GetOfferingOrderQuoteSelector(inputSelectors) {
  return createSelector(inputSelectors, function (offerWizardStore) {
    return offerWizardStore && Object.keys(offerWizardStore).length ? mapOfferingQuoteProperties(offerWizardStore) : EMPTY_OBJECT;
  });
};
export var GetOfferQuoteFinanceCreditLimitSelector = function GetOfferQuoteFinanceCreditLimitSelector(inputSelectors) {
  return createSelector(inputSelectors, function (offerWizardStore) {
    return offerWizardStore ? offerWizardStore.financeCreditLimitValidation : undefined;
  });
};
export var GetTotalDownPaymentAmountSelector = function GetTotalDownPaymentAmountSelector(inputSelectors) {
  return createSelector(inputSelectors, function (offerQuote) {
    return pathOr(null, ['Totals', 'DownPaymentAmount'], offerQuote);
  });
};
export var GetQuoteHasInvoiceItemsSelector = function GetQuoteHasInvoiceItemsSelector(inputSelectors) {
  return createSelector(inputSelectors, function (offerQuote) {
    return offerQuote && offerQuote.HasInvoiceItems || null;
  });
};
var getOrderQuoteSortOrder = function getOrderQuoteSortOrder(chargeTiming) {
  switch (chargeTiming) {
    case CHARGE_TIMING.DUE_TODAY:
      return 1;
    case CHARGE_TIMING.DUE_ON_ACTIVATION:
      return 2;
    case CHARGE_TIMING.DUE_ON_FIRST_USE:
      return 3;
    case CHARGE_TIMING.BILL_CYCLE:
      return 4;
    case CHARGE_TIMING.DUE_RECURRING:
      return 5;
    default:
      return 0;
  }
};
export var GetPostQuoteDueTotalsSelector = function GetPostQuoteDueTotalsSelector(inputSelectors) {
  return createImmutableSelector(inputSelectors, function (quote) {
    var orderQuoteTotals = pathOr(EMPTY_ARRAY, ['OrderQuoteTotals'], quote);
    if (orderQuoteTotals.length) {
      return {
        orderQuoteTotals: orderQuoteTotals.map(function (orderQuoteTotal) {
          return {
            chargeTiming: orderQuoteTotal.ChargeTiming,
            discountAmount: orderQuoteTotal.DiscountAmount,
            sortOrder: getOrderQuoteSortOrder(orderQuoteTotal.ChargeTiming),
            subTotalAmount: orderQuoteTotal.SubTotalAmount,
            feeAmount: orderQuoteTotal.FeeAmount,
            taxAmount: orderQuoteTotal.TaxAmount,
            shippingAmount: orderQuoteTotal.ShippingAmount || undefined,
            totalAmount: orderQuoteTotal.TotalAmount
          };
        })
      };
    }
  });
};
export var GetPreQuoteDueSubTotalsSelector = function GetPreQuoteDueSubTotalsSelector(inputSelectors) {
  return createImmutableSelector(inputSelectors, function (shoppingCart) {
    var subTotalDueToday = pathOr(null, ['SubTotals', 'DueToday'], shoppingCart);
    var subTotalDueNextInvoice = pathOr(null, ['SubTotals', 'DueNextInvoice'], shoppingCart);
    var subTotalDueRecurring = pathOr(null, ['SubTotals', 'DueRecurring'], shoppingCart);
    var subTotalDueOnActivation = pathOr(null, ['SubTotals', 'DueOnActivation'], shoppingCart);
    var subTotalDueOnFirstUse = pathOr(null, ['SubTotals', 'DueOnFirstUse'], shoppingCart);
    return {
      dueToday: {
        subTotal: subTotalDueToday
      },
      dueNextInvoice: {
        subTotal: subTotalDueNextInvoice
      },
      dueOnActivation: {
        subTotal: subTotalDueOnActivation
      },
      dueOnFirstUse: {
        subTotal: subTotalDueOnFirstUse
      },
      dueRecurring: {
        subTotal: subTotalDueRecurring
      }
    };
  });
};
var hasInactiveCharges = function hasInactiveCharges() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
  return items.some(function (item) {
    var recurringBillerRuleInstances = pathOr(EMPTY_ARRAY, ['Details', 'PricingPlan', 'PricingPlanBillerRuleInstances', 'RecurringBillerRuleInstances'], item);
    var oneTimeBillerRuleInstances = pathOr(EMPTY_ARRAY, ['Details', 'PricingPlan', 'PricingPlanBillerRuleInstances', 'OneTimeBillerRuleInstances'], item);
    return [].concat(_toConsumableArray(recurringBillerRuleInstances), _toConsumableArray(oneTimeBillerRuleInstances)).some(function (billerRuleInstance) {
      return billerRuleInstance.DefaultActivationStatus === BRI_ACTIVATION_STATUS.INACTIVE;
    });
  });
};
var getItemDeposits = function getItemDeposits(shoppingCartItem) {
  var pricingPlanDepositItem = [];
  if (shoppingCartItem.Deposits && shoppingCartItem.Deposits.length) {
    shoppingCartItem.Deposits.forEach(function (deposit) {
      pricingPlanDepositItem.push({
        TotalAmount: deposit.TotalAmount,
        DisplayName: shoppingCartItem.Details.PricingPlan.Deposits.find(propEq(deposit.DepositTypeId, 'DepositTypeId')).DisplayName
      });
    });
  }
  return pricingPlanDepositItem;
};
var getBillerRuleCharges = function getBillerRuleCharges(briItems) {
  var briCharges = [];
  if (briItems) {
    briItems.forEach(function (briItem) {
      briCharges.push(briItem.BillerRuleInstanceCharges[0].ChargeAmount);
    });
  }
  return briCharges;
};
var getBriAmount = function getBriAmount(bri, briTotals) {
  var briTotalAmount = [];
  if (briTotals && briTotals.length) {
    briTotals.forEach(function (item) {
      briTotalAmount.push({
        type: item.Type,
        amount: item.Amount,
        discount: item.DiscountAmount,
        billerRuleConfigurationId: item.BillerRuleConfigurationId
      });
    });
  } else if (bri.Type === BILLER_RULE_INSTANCE_TYPE.SUBSCRIPTION) {
    briTotalAmount.push({
      type: bri.Type,
      amount: bri.Amount,
      discount: bri.DiscountAmount
    });
  } else {
    briTotalAmount.push({
      type: bri.Type,
      amount: briTotals && briTotals.length ? briTotals.find(function (briTotal) {
        return briTotal.Type === bri.Type;
      }).Amount : undefined,
      discount: briTotals && briTotals.length ? briTotals.find(function (briTotal) {
        return briTotal.Type === bri.Type;
      }).DiscountAmount : undefined
    });
  }
  return briTotalAmount;
};
var getStandaloneUsageProducts = function getStandaloneUsageProducts(productsByType) {
  var standaloneUsageProducts = [];
  var usageProducts = productsByType[BILLER_RULE_INSTANCE_TYPE.USAGE] || [];
  usageProducts.forEach(function (product) {
    var isOneTimeProduct = (productsByType[BILLER_RULE_INSTANCE_TYPE.ONETIME] || []).some(function (oneTimeProduct) {
      return oneTimeProduct.pricingPlanId === product.pricingPlanId;
    });
    var isRecurringProduct = (productsByType[BILLER_RULE_INSTANCE_TYPE.RECURRING] || []).some(function (recurringProduct) {
      return recurringProduct.pricingPlanId === product.pricingPlanId;
    });
    if (!isOneTimeProduct && !isRecurringProduct) {
      standaloneUsageProducts.push(product);
    }
  });
  return standaloneUsageProducts;
};
var getStandaloneUsageProductGroups = function getStandaloneUsageProductGroups(productsByType) {
  var standaloneUsageProductGroups = [];
  var standaloneUsageProducts = getStandaloneUsageProducts(productsByType);
  if (standaloneUsageProducts.length) {
    standaloneUsageProductGroups.push({
      currentRecurring: 0,
      invoiceTimingTypes: null,
      type: i18n.translate(CustomerCareKeys.BILLER_RULE_INSTANCE_TYPES.USAGE),
      products: standaloneUsageProducts,
      totalAmount: 0,
      totalDiscounts: 0
    });
  }
  return standaloneUsageProductGroups;
};
export var SummaryTab = function SummaryTab(inputSelectors) {
  return createSelector(inputSelectors, function (shoppingCart, subTotalAmount, taxAmount, totalAmount, quoteCalculated, selectedContract, creditAmount, quoteOnly, totalDownPayment, postQuoteDueTotals, preQuoteDueSubTotals) {
    var isAddOffer = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : false;
    var multiOfferShoppingCart = arguments.length > 12 ? arguments[12] : undefined;
    // quoteOnly is the skip building out deposits and productsGroups, this is needed to support multi offer

    var quoteOnlyViewModel = {
      contract: selectedContract ? selectedContract : null,
      creditAmount: creditAmount || 0,
      deposits: EMPTY_ARRAY,
      productGroups: EMPTY_ARRAY,
      productsByType: EMPTY_OBJECT,
      currencyCode: (multiOfferShoppingCart === null || multiOfferShoppingCart === void 0 ? void 0 : multiOfferShoppingCart.Currency) || (shoppingCart === null || shoppingCart === void 0 ? void 0 : shoppingCart.Currency),
      discountAmount: shoppingCart.DiscountAmount || 0,
      totalAmount: shoppingCart.TotalAmount || 0,
      taxNotIncluded: !quoteCalculated,
      subTotalAmount: subTotalAmount,
      subTotalDeposits: isAddOffer ? multiOfferShoppingCart.DepositAmount : shoppingCart.DepositAmount,
      taxQuoteAmount: taxAmount,
      totalDownPayment: totalDownPayment,
      totalQuoteAmount: totalAmount,
      dueTotals: postQuoteDueTotals,
      dueSubTotals: preQuoteDueSubTotals
    };
    if (quoteOnly) {
      return quoteOnlyViewModel;
    }
    var newItems = shoppingCart.Items || [];
    if (shoppingCart.AddItems && shoppingCart.AddItems.length && shoppingCart.Items && shoppingCart.Items.length) {
      newItems = shoppingCart.Items.map(function (item) {
        var addedItem = shoppingCart.AddItems.find(function (addItem) {
          return !item.LockerItemId && addItem.ProductId === item.ProductId && addItem.PricingPlanId === item.PricingPlanId;
        });
        return Object.assign({}, item, {
          isAdded: addedItem ? true : null
        });
      });
    }
    var combinedItems = combineItems(newItems, shoppingCart);
    if (combinedItems.length) {
      var mapBillerRuleToViewModel = map(function (item) {
        var filterInvalidItems = filterInvalidItem(item, item.Details.BillerRuleTotals);
        return filterInvalidItems.map(function (billerRule) {
          var itemWithBritInfo = {
            briAmount: getBriAmount(billerRule, !billerRule.length && billerRule.Type === BILLER_RULE_INSTANCE_TYPE.FINANCE ? [billerRule.billerRuleTotal] : item.Details.PricingPlan.BillerRuleInstanceThumbnails),
            billerRule: billerRule,
            billCycleName: pathOr('', ['Details', 'PricingPlan', 'SubscriptionBillingCycleName'], item),
            billerRuleDetails: getBillerRuleDetails(item.Details.PricingPlan.BillerRuleInstanceThumbnails, item.ShoppingCartItemBillerRuleDetails),
            currencyCode: shoppingCart.Currency || DEFAULT_SUMMARY_TAB_VIEW_MODEL.currencyCode,
            //TODO: ASCINV-642 mini cart discounts
            //discountAmount: billerRule.DiscountAmount,
            inventoryAttributes: pathOr([], ['PhysicalInventories', 0, 'InventoryAttributes'], item),
            isAdded: item.isAdded ? item.isAdded : null,
            hasOverriddenPrice: hasOverriddenPrice(Array.isArray(billerRule) ? billerRule : [billerRule], item.ShoppingCartItemBillerRuleDetails),
            isFinance: !billerRule.length ? billerRule.Type === BILLER_RULE_INSTANCE_TYPE.FINANCE : false,
            isModified: item.isModified ? item.isModified : null,
            isRemoved: item.isRemoved ? item.isRemoved : null,
            isStandalone: item.IsStandalone,
            isSwapped: item.OrderItemChangeType ? item.OrderItemChangeType === PLAN_OR_SERVICE_SWAP : null,
            itemDeposits: getItemDeposits(item),
            name: item.Details.Product.Name,
            offeringOptionId: item.OfferingOptionId,
            offeringOptionPriceId: item.OfferingOptionPriceId,
            oneTimeCharge: getBillerRuleCharges(item.Details.PricingPlan.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances),
            pricingPlanId: item.PricingPlanId,
            pricingPlanName: item.Details.PricingPlan.Name,
            productId: item.ProductId,
            quantity: item.Quantity,
            recurringCharge: getBillerRuleCharges(item.Details.PricingPlan.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances),
            termLength: (billerRule === null || billerRule === void 0 ? void 0 : billerRule.Type) === BILLER_RULE_INSTANCE_TYPE.FINANCE ? pathOr(null, ['ShoppingCartItemBillerRuleDetails', 0, 'TermLength'], item) : null,
            thumbnailUrl: item.Details.Product.ThumbnailUrl
          };
          if (itemWithBritInfo.isFinance) {
            //TODO: Remove once the dependency of summary tab with finance is removed from wizards other than add offer
            itemWithBritInfo.addedItemIndex = item.addedItemIndex;
            itemWithBritInfo.downPayment = item.downPayment;
            itemWithBritInfo.downPaymentType = item.DownPaymentType || undefined;
            itemWithBritInfo.isFullPriceDownPaymentSelected = item.isFullPriceDownPaymentSelected;
            itemWithBritInfo.isDownPaymentEqualToFirstSelected = item.isDownPaymentEqualToFirstSelected;
            itemWithBritInfo.isDownPaymentEqualToFirstInstallment = item.Details.PricingPlan.PricingPlanBillerRuleInstances.FinanceBillerRuleInstances[0].DownPaymentEqualToFirstInstallment;
            itemWithBritInfo.isFullUpfrontPayment = item.isFullUpfrontPayment;
            itemWithBritInfo.itemIndex = item.itemIndex;
            itemWithBritInfo.minimumDownPayment = item.minimumDownPayment;
          }
          return itemWithBritInfo;
        });
      });
      var groupBillerTypes = groupBy(function (billerVM) {
        if (billerVM.itemDeposits.length) {
          return CHARGE_TIMING.DUE_TODAY;
        } else if (billerVM.billerRule.length) {
          switch (billerVM.billerRule[0].BillerRuleConfigurationChargeDetails.ChargeTiming) {
            case CHARGE_TIMING.BILL_CYCLE:
              return CHARGE_TIMING.BILL_CYCLE;
            case CHARGE_TIMING.DUE_ON_ACTIVATION:
              return CHARGE_TIMING.DUE_ON_ACTIVATION;
            case CHARGE_TIMING.DUE_ON_FIRST_USE:
              return CHARGE_TIMING.DUE_ON_FIRST_USE;
            case CHARGE_TIMING.DUE_TODAY:
              return CHARGE_TIMING.DUE_TODAY;
            default:
              break;
          }
        } else if (billerVM.billerRule.BillerRuleConfigurationChargeDetails) {
          switch (billerVM.billerRule.BillerRuleConfigurationChargeDetails.ChargeTiming) {
            case CHARGE_TIMING.BILL_CYCLE:
              return CHARGE_TIMING.BILL_CYCLE;
            case CHARGE_TIMING.DUE_ON_ACTIVATION:
              return CHARGE_TIMING.DUE_ON_ACTIVATION;
            case CHARGE_TIMING.DUE_ON_FIRST_USE:
              return CHARGE_TIMING.DUE_ON_FIRST_USE;
            case CHARGE_TIMING.DUE_TODAY:
              return CHARGE_TIMING.DUE_TODAY;
            default:
              break;
          }
        } else if (billerVM.billerRule.Type === BILLER_RULE_INSTANCE_TYPE.FINANCE) {
          if (billerVM.isFinance && billerVM.billerRule.billerRuleTotal) {
            if (billerVM.billerRule.billerRuleTotal.ChargeTiming === CHARGE_TIMING.DUE_TODAY) {
              return CHARGE_TIMING.DUE_TODAY;
            } else if (billerVM.billerRule.billerRuleTotal.ChargeTiming === CHARGE_TIMING.BILL_CYCLE) {
              return CHARGE_TIMING.BILL_CYCLE;
            }
          }
        } else if (billerVM.billerRule.Type === BILLER_RULE_INSTANCE_TYPE.SUBSCRIPTION) {
          return CHARGE_TIMING.DUE_TODAY;
        }
      });
      var groupItems = groupBy(function (item) {
        return item.PricingPlanId;
      }, combinedItems || []);
      var combinedItemBris = compose(flatten, mapBillerRuleToViewModel)(combinedItems);
      var itemWithMultipleBris = combinedItemBris.find(function (item) {
        return item.recurringCharge.length > 1 || item.oneTimeCharge.length > 1;
      });
      var productsByType = [];
      if (itemWithMultipleBris) {
        var selectedPlansWithBri = [];
        for (var plan in groupItems) {
          groupItems[plan].forEach(function (planItem) {
            var selectedBri = combinedItemBris.find(function (item) {
              return item.pricingPlanId === planItem.PricingPlanId;
            });
            if (selectedBri) {
              selectedPlansWithBri.push(selectedBri);
            }
          });
        }
        productsByType = compose(groupBillerTypes)(selectedPlansWithBri);
      } else {
        productsByType = compose(groupBillerTypes)(combinedItemBris);
      }
      var groupBriByTypes = groupBy(function (billerVM) {
        return billerVM.billerRule.Type;
      });
      var productsByBriType = compose(groupBriByTypes, flatten, mapBillerRuleToViewModel)(combinedItems);
      var productGroups = Object.keys(productsByBriType).filter(function (type) {
        type = +type;
        return type === BILLER_RULE_INSTANCE_TYPE.RECURRING || type === BILLER_RULE_INSTANCE_TYPE.ONETIME || type === BILLER_RULE_INSTANCE_TYPE.FINANCE || type === BILLER_RULE_INSTANCE_TYPE.SUBSCRIPTION;
      }).map(function (type) {
        type = +type;
        return {
          // For Finance BRI we are having different objects based on charge timing since we need to show two charges on the cart
          // for down payment and down payment equal to first installment scenarios. For Full upfront payment scenario in finance plans we will only have one charge so we dont need to filter it.
          // So for type finance BRI when there is down payment we are filtering one of the duplicate BRI which we needed for the cart
          // 'downPayment' value doesnt change (which we are showing on the checkout screen), for every BRI object, down payment is calculated before this function is fired.
          products: type === BILLER_RULE_INSTANCE_TYPE.FINANCE ? productsByBriType[type].filter(function (item) {
            return item.billerRule.billerRuleTotal.ChargeTiming === CHARGE_TIMING.BILL_CYCLE || item.billerRule.FullUpfrontPayment;
          }) : productsByBriType[type],
          typeCode: type
        };
      }).concat(getStandaloneUsageProductGroups(productsByBriType));
      return Object.assign({}, quoteOnlyViewModel, {
        dueSubTotals: preQuoteDueSubTotals,
        dueTotals: postQuoteDueTotals,
        hasInactiveCharges: hasInactiveCharges(shoppingCart.Items),
        offerName: pathOr(undefined, [0, 'OrderedOfferingName'], shoppingCart.Items),
        productsByType: productsByType,
        productGroups: productGroups,
        totalAmount: shoppingCart.TotalAmount || 0
      });
    } else {
      return DEFAULT_SUMMARY_TAB_VIEW_MODEL;
    }
  });
};

//Todo: remove once the dependency of summary tab with finance is removed from wizards other than add offer
export var GetSummaryTabFinancedGroupSelector = function GetSummaryTabFinancedGroupSelector(inputSelectors) {
  return createSelector(inputSelectors, function (summaryTabViewModel) {
    return summaryTabViewModel.productGroups.find(function (productGroup) {
      return productGroup.typeCode === BILLER_RULE_INSTANCE_TYPE.FINANCE;
    });
  });
};
export var EditOptions = function EditOptions(inputSelectors) {
  return createSelector(inputSelectors, function (editCart) {
    return pathOr(null, ['editOptions'], editCart);
  });
};
export var SelectedEditOption = function SelectedEditOption(inputSelectors) {
  return createSelector(inputSelectors, function (editCart) {
    return pathOr(null, ['selectedEditOption'], editCart);
  });
};
export var getFilteredBillerRuleDetailsForBriId = function getFilteredBillerRuleDetailsForBriId(briId) {
  var billerRuleDetails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var billerRuleDetailsForBriId = (billerRuleDetails || []).filter(propEq(briId, 'BillerRuleConfigurationId'));
  return billerRuleDetailsForBriId.length ? billerRuleDetailsForBriId : [{
    Amount: null,
    EndDate: null,
    Quantity: null,
    StartDate: null
  }];
};
export var EditOption = function EditOption(inputSelectors) {
  return createSelector(inputSelectors, function (selectedEditOption, editOptions) {
    if (!selectedEditOption || !editOptions) {
      return null;
    }
    var editOption = editOptions.find(propEq(selectedEditOption, 'Id')).asMutable({
      deep: true
    });
    editOption.BillerRuleInstanceThumbnails.forEach(function (brit) {
      var billerRuleDetails = getFilteredBillerRuleDetailsForBriId(brit.BillerRuleConfigurationId, editOption.BillerRuleDetails);
      if (!(billerRuleDetails.length === 1 && billerRuleDetails[0].TermLength)) {
        brit.pricingPeriods = brit.pricingPeriods || billerRuleDetails.map(function (billerRuleDetail) {
          return {
            Amount: typeof billerRuleDetail.Amount === 'number' ? billerRuleDetail.Amount : brit.Amount,
            EndDate: billerRuleDetail.EndDate || null,
            Quantity: billerRuleDetail.Quantity,
            StartDate: billerRuleDetail.StartDate || null
          };
        });
        var isDateSpecified = brit.pricingPeriods.some(function (pricingPeriod) {
          return pricingPeriod.StartDate !== null || pricingPeriod.EndDate !== null;
        });
        brit.scheduleType = isDateSpecified ? ScheduleTypes.CUSTOM : brit.scheduleType || ScheduleTypes.NONE;
      }
    });
    return editOption;
  });
};
export var ServiceAddress = function ServiceAddress(inputSelectors) {
  return createSelector(inputSelectors, function (wizardStore) {
    return wizardStore.serviceAddress;
  });
};
export var PaymentInfo = function PaymentInfo(inputSelectors) {
  return createSelector(inputSelectors, function (cart) {
    return cart.paymentInfo;
  });
};
export var getItemRsvp = function getItemRsvp(attribute) {
  return !attribute.inventoryItemReservation || attribute.passPortIn ? null : {
    InstanceId: attribute.inventoryItemReservation.instanceId || attribute.inventoryItemReservation.InstanceId,
    InventoryTypeId: attribute.inventoryItemReservation.inventoryTypeId || attribute.inventoryTypeId,
    SerialNumber: attribute.inventoryItemReservation.serialNumber,
    Token: attribute.inventoryItemReservation.token
  };
};
export var getPortInRequest = function getPortInRequest(attribute) {
  return !attribute.portInRequest || !attribute.passPortIn ? null : {
    AdditionalProperties: attribute.portInRequest.portInData.mnpAdditionalProps,
    PortInNumber: attribute.portInRequest.portInData.existingNumber,
    InventoryTypeId: attribute.inventoryTypeId,
    ServiceAttributeId: null,
    ValidationToken: attribute.mnpToken,
    Address: attribute.address,
    ServiceProviderId: attribute.portInRequest.portInData.provider
  };
};
var getServiceFeatureAttribute = function getServiceFeatureAttribute(attribute, backupServiceFeatures) {
  var _backupServiceFeature;
  if (backupServiceFeatures !== null && backupServiceFeatures !== void 0 && (_backupServiceFeature = backupServiceFeatures.serviceFeatures) !== null && _backupServiceFeature !== void 0 && _backupServiceFeature.length && attribute.dependentServiceAttributeId === backupServiceFeatures.dependentServiceAttributeId) {
    var _attribute$serviceFea;
    var oldServiceFeature = backupServiceFeatures.serviceFeatures.map(function (serviceAttribute) {
      return _objectSpread(_objectSpread({}, serviceAttribute), {}, {
        ServiceAttributeId: attribute.serviceAttributeId
      });
    });
    if ((_attribute$serviceFea = attribute.serviceFeature) !== null && _attribute$serviceFea !== void 0 && _attribute$serviceFea.length) {
      return [].concat(_toConsumableArray(oldServiceFeature), _toConsumableArray(attribute.serviceFeatures));
    } else {
      return oldServiceFeature;
    }
  } else {
    return attribute.serviceFeatures;
  }
};
var EMPTY_FORMATTED_ATTRIBUTES = [];
export var FormattedAttributes = function FormattedAttributes(inputSelectors) {
  return createSelector(inputSelectors, function (editCart) {
    if (editCart.editAttributeGroups) {
      return editCart.editAttributeGroups.reduce(function (result, attributeGroup) {
        var backupServiceFeatures = {};
        var transformedAttrs = attributeGroup.filter(function (attribute) {
          if (attribute.isHidden && (attribute.formValue || attribute.serviceFeatures && attribute.serviceFeatures.length) && attribute.serviceAttributeId === DEVICE_SERVICE_FEATURE_ATTRIBUTE_ID) {
            return true;
          } else if (attribute.isHidden && attribute.serviceFeatures && attribute.serviceFeatures.length) {
            backupServiceFeatures = {
              dependentServiceAttributeId: attribute.dependentServiceAttributeId,
              serviceFeatures: attribute.serviceFeatures
            };
          } else {
            return !attribute.isHidden;
          }
        }).map(function (attribute) {
          return {
            BillerRuleInstanceDetails: attribute.billerRuleInstanceDetails,
            DecisionType: DecisionTypes.SERVICE_ATTRIBUTE,
            Id: attribute.id,
            InventoryItemReservation: getItemRsvp(attribute),
            PortInRequest: getPortInRequest(attribute),
            SelectedValue: attribute.formValue || null,
            //Needs to default to null so RoC doesn't treat it as a modify item
            ServiceFeatures: getServiceFeatureAttribute(attribute, backupServiceFeatures),
            ServiceInstanceId: attribute.serviceInstanceId
          };
        });
        return result.concat(transformedAttrs);
      }, []).asMutable({
        deep: true
      });
    } else {
      return EMPTY_FORMATTED_ATTRIBUTES;
    }
  });
};
var createCompletedPhysicalInventoryItemRequests = function createCompletedPhysicalInventoryItemRequests(offerId, storeId, attribute) {
  return {
    Id: attribute.id,
    DecisionType: DecisionTypes.PHYSICAL_INVENTORY,
    PhysicalInventoryCompletedDecision: {
      MakeId: attribute.selectedMake,
      ModelId: attribute.selectedModel,
      InventoryAttributes: Object.keys(attribute.selectedTypeAttributes || {}).map(function (key) {
        return {
          AttributeId: key,
          AttributeValue: attribute.selectedTypeAttributes[key]
        };
      }),
      Quantity: 1,
      StoreId: storeId,
      InventoryTypeId: attribute.inventoryTypeId,
      SubscriberProductId: attribute.subscriberProductId
    }
  };
};
var removeUndefinedAttributes = function removeUndefinedAttributes(formattedDecision) {
  var physicalInventoryCompletedDecisions = formattedDecision.PhysicalInventoryCompletedDecision;
  return Object.assign(formattedDecision, {
    PhysicalInventoryCompletedDecision: Object.assign(physicalInventoryCompletedDecisions, {
      InventoryAttributes: physicalInventoryCompletedDecisions.InventoryAttributes.reduce(function (acc, next) {
        return next.AttributeValue ? acc.concat(next) : acc;
      }, [])
    })
  });
};
export var FormattedPhysicalAttributes = function FormattedPhysicalAttributes(inputSelectors) {
  return createSelector(inputSelectors, function (editCart, offerId, stores) {
    if (editCart.editPhysicalAttributeGroups) {
      return flatten(values(editCart.editPhysicalAttributeGroups)).map(partial(createCompletedPhysicalInventoryItemRequests, [offerId, stores && stores.length ? stores[0] : null])).map(removeUndefinedAttributes);
    } else {
      return EMPTY_FORMATTED_ATTRIBUTES;
    }
  });
};
export var SubscriberProductIdUndefinedSelector = function SubscriberProductIdUndefinedSelector(inputSelectors) {
  return createSelector(inputSelectors, function (group) {
    if (group) {
      var itemWithoutSubscriberProductId = group.find(function (item) {
        return item.PhysicalInventoryCompletedDecision.SubscriberProductId === undefined;
      });
      return itemWithoutSubscriberProductId ? true : false;
    }
  });
};
export var formatPhysicalInventory = function formatPhysicalInventory(shoppingCartItem) {
  var sortedAndFormattedInventoryAttributes = shoppingCartItem.InventoryAttributes.map(function (invAttribute) {
    return {
      AttributeId: invAttribute.AttributeId,
      AttributeValue: invAttribute.AttributeValue
    };
  });
  return {
    DisplayName: shoppingCartItem.DisplayName,
    InventoryTypeId: shoppingCartItem.InventoryTypeId,
    MakeId: shoppingCartItem.MakeId,
    ModelId: shoppingCartItem.ModelId,
    OfferingInstanceId: shoppingCartItem.OfferingInstanceId,
    Quantity: 1,
    InventoryAttributes: sortedAndFormattedInventoryAttributes
  };
};
export var AvailableCreditFromQuote = function AvailableCreditFromQuote(inputSelectors) {
  return createImmutableSelector(inputSelectors, function (offerWizardOrderQuote) {
    return offerWizardOrderQuote && offerWizardOrderQuote.AvailableCredit || null;
  });
};
export var IsCreditLimitBreachedFromQuote = function IsCreditLimitBreachedFromQuote(inputSelectors) {
  return createImmutableSelector(inputSelectors, function (offerWizardOrderQuote) {
    return offerWizardOrderQuote && offerWizardOrderQuote.IsCreditLimitBreached || false;
  });
};
export var FinanceCreditFromQuoteSelector = function FinanceCreditFromQuoteSelector(inputSelectors) {
  return createImmutableSelector(inputSelectors, function (financeCreditLimitOrderQuote) {
    return financeCreditLimitOrderQuote && financeCreditLimitOrderQuote.ExceededFinanceCreditLimitAmount || null;
  });
};
export var IsSendToStoreButtonEnabledSelectorCreator = function IsSendToStoreButtonEnabledSelectorCreator(inputSelectors) {
  return createImmutableSelector(inputSelectors, function (physicalInventory, isAttributesStep, isCheckoutStep, asyncId) {
    return !!((isAttributesStep || isCheckoutStep) && physicalInventory.length && !asyncId);
  });
};
export var GetCartAdditionalPropertiesSelector = function GetCartAdditionalPropertiesSelector(inputSelectors) {
  return createImmutableSelector(inputSelectors, function (offerWizardStore) {
    return offerWizardStore.cartAdditionalProperties;
  });
};
export var GetOrderAdditionalPropertiesSelector = function GetOrderAdditionalPropertiesSelector(inputSelectors) {
  return createImmutableSelector(inputSelectors, function (offerWizardStore) {
    return offerWizardStore.orderAdditionalProperties;
  });
};
export var GetOfferAdditionalPropertiesSelector = function GetOfferAdditionalPropertiesSelector(inputSelectors) {
  return createImmutableSelector(inputSelectors, function (offerWizardStore) {
    return offerWizardStore.offerAdditionalProperties;
  });
};
export var GetAdditionalPropertyListMapSelector = function GetAdditionalPropertyListMapSelector(inputSelectors) {
  return createImmutableSelector(inputSelectors, function (additionalPropertyValues, additionalPropertyFields) {
    return additionalPropertiesMergeValuesIntoTemplate(additionalPropertyFields, additionalPropertyValues);
  });
};
export var DeliveryOptionsByPricingPlanHelper = function DeliveryOptionsByPricingPlanHelper(inputSelectors) {
  return createImmutableSelector(inputSelectors, function (deliveryDecisions, shippingMethods) {
    var shippableDeliveryDecisions = deliveryDecisions.filter(function (deliveryDecision) {
      return deliveryDecision.Shippable;
    });
    return shippableDeliveryDecisions.reduce(function (pricingPlanByDeliveryOptions, shippableDeliveryDecision) {
      var deliveryOptions = (shippingMethods || []).reduce(function (accumulator, shippingMethod) {
        var isAvailableShippingMethod = shippableDeliveryDecision.AvailableShippingMethods.some(function (availableShippingMethodId) {
          return availableShippingMethodId === shippingMethod.Id;
        });
        if (isAvailableShippingMethod) {
          accumulator.push({
            name: shippingMethod.Name,
            shippingCost: shippingMethod.ShippingCost,
            currency: shippingMethod.Currency
          });
        }
        return accumulator;
      }, []);
      pricingPlanByDeliveryOptions[shippableDeliveryDecision.PricingPlanId] = pricingPlanByDeliveryOptions[shippableDeliveryDecision.PricingPlanId] || {};
      pricingPlanByDeliveryOptions[shippableDeliveryDecision.PricingPlanId][shippableDeliveryDecision.InstanceNumber] = Object.assign({}, shippableDeliveryDecision, {
        deliveryOptions: deliveryOptions,
        selectedValue: shippableDeliveryDecision.SelectedValue || DELIVERY_OPTIONS.STORE_PICKUP
      });
      return pricingPlanByDeliveryOptions;
    }, {});
  });
};
export var TaxLocationDecisionsByPricingPlanHelper = function TaxLocationDecisionsByPricingPlanHelper(inputSelectors) {
  return createImmutableSelector(inputSelectors, function (taxLocationDecisions) {
    return taxLocationDecisions.reduce(function (pricingPlanByTaxLocationOptions, taxLocationDecision) {
      pricingPlanByTaxLocationOptions[taxLocationDecision.PricingPlanId] = pricingPlanByTaxLocationOptions[taxLocationDecision.PricingPlanId] || {};
      pricingPlanByTaxLocationOptions[taxLocationDecision.PricingPlanId][taxLocationDecision.InstanceNumber] = Object.assign({}, taxLocationDecision);
      pricingPlanByTaxLocationOptions[taxLocationDecision.PricingPlanId][taxLocationDecision.InstanceNumber]['taxOption'] = pricingPlanByTaxLocationOptions[taxLocationDecision.PricingPlanId][taxLocationDecision.InstanceNumber].ServiceTaxCustomization.OriginatingPercentage ? TAX_RULE_OPTIONS.CUSTOM : TAX_RULE_OPTIONS.DEFAULT;
      return pricingPlanByTaxLocationOptions;
    }, {});
  });
};
export var FormattedDeliveryDecisions = function FormattedDeliveryDecisions(inputSelectors) {
  return createImmutableSelector(inputSelectors, function (deliveryDecisions) {
    var formattedDeliveryDecisions = [];
    if (deliveryDecisions.length) {
      deliveryDecisions.forEach(function (item) {
        formattedDeliveryDecisions.push({
          DecisionType: item.DecisionType,
          Id: item.Id,
          SelectedValue: item.SelectedValue
        });
      });
    }
    return formattedDeliveryDecisions.length ? formattedDeliveryDecisions : EMPTY_ARRAY;
  });
};
export var OfferingOrderOffCycleAlignmentOptionsSelector = function OfferingOrderOffCycleAlignmentOptionsSelector(inputSelectors) {
  return createSelector(inputSelectors, function (shoppingCart, metadata, offCycleAlignmentOptions, serviceAttributeCodeTable, regularExpressionCodeTable) {
    var offers = {};
    var offersToServiceIdentifiers = {};
    shoppingCart && shoppingCart.Items && shoppingCart.Items.forEach(function (item) {
      if (!(item.Details.PricingPlan.PricingPlanBillerRuleInstances.TriggerBillerRuleInstances.length && item.Details.PricingPlan.PricingPlanBillerRuleInstances.TriggerBillerRuleInstances[0].TriggerType === BILLER_RULE_INSTANCE_TYPE.ONETIME)) {
        var pricingPlan = {
          id: item.PricingPlanId,
          productId: item.ProductId,
          pricingPlanName: metadata[item.OfferingId] ? metadata[item.OfferingId].PricingPlanThumbnails[item.PricingPlanId].Name : undefined,
          options: offCycleAlignmentOptions[item.PricingPlanId] || []
        };
        if (item.ServiceAttributes && item.ServiceAttributes.length) {
          offersToServiceIdentifiers[item.OfferingInstanceId] = item.ServiceAttributes;
        }
        if (metadata[item.OfferingId] && !!offCycleAlignmentOptions[item.PricingPlanId]) {
          if (offers[item.OfferingInstanceId]) {
            if (offers[item.OfferingInstanceId].pricingPlans) {
              offers[item.OfferingInstanceId].pricingPlans.push(pricingPlan);
            } else {
              offers[item.OfferingInstanceId].pricingPlans = [pricingPlan];
            }
          } else {
            offers[item.OfferingInstanceId] = {
              offerName: metadata[item.OfferingId].Name,
              offeringInstanceId: item.OfferingInstanceId
            };
            offers[item.OfferingInstanceId].pricingPlans = [pricingPlan];
          }
        }
        if (offers[item.OfferingInstanceId]) {
          offers[item.OfferingInstanceId]['serviceAttributes'] = offersToServiceIdentifiers[item.OfferingInstanceId] && offersToServiceIdentifiers[item.OfferingInstanceId].length ? getUniqueNonGuidServiceIdentifiers(offersToServiceIdentifiers[item.OfferingInstanceId], serviceAttributeCodeTable, regularExpressionCodeTable) : '';
        }
      }
    });
    return Object.values(offers).filter(function (offer) {
      return offer.pricingPlans;
    });
  });
};
export var OfferingOrderProductIdsAndPricingPlanIdsOffCycleOfferSelector = function OfferingOrderProductIdsAndPricingPlanIdsOffCycleOfferSelector(inputSelectors) {
  return createSelector(inputSelectors, function (shoppingCart, offeringMetadataById) {
    var offCycleOffers = shoppingCart && shoppingCart.Items ? shoppingCart.Items.filter(function (item) {
      return offeringMetadataById[item.OfferingId] && offeringMetadataById[item.OfferingId].BillerRuleCycleLevel === BILLER_RULE_CYCLE_LEVEL.ITEM;
    }) : [];
    return offCycleOffers.map(function (item) {
      return {
        PricingPlanId: item.PricingPlanId,
        ProductId: item.ProductId
      };
    });
  });
};
export var SelectedOffCycleAlignmentsSelector = function SelectedOffCycleAlignmentsSelector(inputSelectors) {
  return createSelector(inputSelectors, function (subscriberProductData, alignmentOptions) {
    return alignmentOptions.map(function (offer) {
      if (subscriberProductData[offer.offeringInstanceId]) {
        return {
          offerName: offer.offerName,
          offeringInstanceId: offer.offeringInstanceId,
          serviceAttributes: offer.serviceAttributes,
          pricingPlans: offer.pricingPlans.map(function (pricingPlan) {
            if (subscriberProductData[offer.offeringInstanceId][pricingPlan.id] && subscriberProductData[offer.offeringInstanceId][pricingPlan.id].nextRenewalDate) {
              return {
                pricingPlanName: pricingPlan.pricingPlanName,
                pricingPlanId: pricingPlan.id,
                subscriberProductId: subscriberProductData[offer.offeringInstanceId][pricingPlan.id].subscriberProductId,
                nextRenewalDate: subscriberProductData[offer.offeringInstanceId][pricingPlan.id].nextRenewalDate
              };
            }
          }).filter(function (pricingPlan) {
            return pricingPlan;
          })
        };
      }
    }).filter(function (offer) {
      return offer && offer.pricingPlans && offer.pricingPlans.length;
    });
  });
};
export var DeliveryMethodOptionsSelector = function DeliveryMethodOptionsSelector(inputSelectors) {
  return createImmutableSelector(inputSelectors, function (deliveryMethods, subscriberCurrency) {
    return deliveryMethods && deliveryMethods.filter(function (deliveryMethod) {
      return deliveryMethod.Currency === subscriberCurrency;
    }).map(function (deliveryMethod) {
      return {
        label: deliveryMethod.Name,
        value: deliveryMethod.Id,
        cost: deliveryMethod.ShippingCost,
        currency: deliveryMethod.Currency
      };
    });
  });
};
export var ShippingAddressWizardSelector = function ShippingAddressWizardSelector(inputSelectors) {
  return createImmutableSelector(inputSelectors, function (isQuoteByPassed, wizardSelector, currentShippingAddress) {
    return isQuoteByPassed ? currentShippingAddress : wizardSelector.shippingAddress;
  });
};
export var ShippingAddressDropdownOptionsWizardSelector = function ShippingAddressDropdownOptionsWizardSelector(inputSelectors) {
  return createSelector(inputSelectors, function (wizardSelector, currentShippingAddress) {
    var shippingAddress = cloneDeep(wizardSelector.offeringOrderQuote && wizardSelector.offeringOrderQuote.Currency && currentShippingAddress ? currentShippingAddress : null);
    var blankBillingAddress = {
      Id: 0,
      Country: null,
      State: null
    };
    var popupAddresses = shippingAddress ? [shippingAddress].concat(blankBillingAddress) : [blankBillingAddress];
    return popupAddresses.map(function (address) {
      address.dropDownString = address.Id === 0 ? i18n.translate(CustomerCareKeys.ADD_NEW) : AddressHelper.createBillingAddressString(address);
      return address;
    });
  });
};
export var GetDownPaymentTypeValue = function GetDownPaymentTypeValue(shoppingCartItem) {
  var item = Object.assign({}, shoppingCartItem);
  if (item.isFullPriceDownPaymentSelected) {
    item.DownPaymentType = DOWN_PAYMENT_TYPE.FULL_UPFRONT_PAYMENT;
  } else if (item.downPayment > 0 && !item.isFullPriceDownPaymentSelected && !item.isDownPaymentEqualToFirstInstallment) {
    item.DownPaymentType = DOWN_PAYMENT_TYPE.DOWN_PAYMENT_WITH_INSTALLMENT;
  } else if (item.isDownPaymentEqualToFirstInstallment !== undefined && item.isDownPaymentEqualToFirstSelected) {
    item.DownPaymentType = DOWN_PAYMENT_TYPE.DOWN_PAYMENT_EQUAL_TO_FIRST_INSTALLMENT;
  }
  return item.DownPaymentType;
};